import type { ProjectFeaturesType } from "@/entities/projects/model/types";
import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
import Typography from "@/shared/ui/Typography";

interface IProjectQualityProps {
    features: ProjectFeaturesType;
}

export function ProjectQualitySection({ features }: IProjectQualityProps) {
    return (
        <SectionLayout
            className=""
            containerClassName="relative flex flex-col gap-[20px] md:gap-[32px] py-[40px]"
        >
            <div className="flex flex-col gap-[20px] md:gap-[28px] md:text-center">
                <Typography tag="h2">качества проекта</Typography>

                <div className="flex flex-col gap-[20px] md:flex-row">
                    <div className="flex flex-col gap-[20px] md:gap-[24px] w-full md:w-1/2 rounded-[10px] shadow-glass gradient-white-bg py-[24px] px-[10px] md:p-[28px]">
                        {features.list.map((item, index) => (
                            <FeatureCard
                                key={index}
                                title={item.name}
                                text={item.description}
                            />
                        ))}
                    </div>

                    <div
                        className="w-full h-[180px] md:h-auto md:flex-1 rounded-[10px] bg-no-repeat bg-cover bg-center"
                        style={{ backgroundImage: `url(${features.imageUrl})` }}
                    />
                </div>
            </div>
        </SectionLayout>
    );
}

const FeatureCard = ({ title, text }: { title: string; text: string }) => {
    return (
        <div className="flex flex-col text-start gap-[16px] md:gap-[20px] pb-[24px] border-b-[1px] border-light-blue last:border-none last:pb-0">
            <Typography className="w-full uppercase text-[18px] md:text-[20px] font-semibold md:font-bold">
                {title}
            </Typography>

            <Typography className="w-full text-[14px] md:text-[16px] font-medium !leading-[120%]">
                {text}
            </Typography>
        </div>
    );
};
